import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// This timestamp will be updated by the rename script
const TRANSLATION_TIMESTAMP = '1761635586135';

export function createTranslateLoader(http: HttpClient) {
  console.log(`Loading translation files with pattern: ./assets/i18n/*.${TRANSLATION_TIMESTAMP}.json`);
  
  return new TranslateHttpLoader(
    http, './assets/i18n/', `.${TRANSLATION_TIMESTAMP}.json`,
  );
}
